import React from "react";
import svg165 from "../../../../assets/svg/svg165.svg";
import { Form, Input, Select, Spin } from "antd";
import svg150 from "../../../../assets/svg/svg150.svg";
import svg151 from "../../../../assets/svg/svg151.svg";
import { useSelector } from "react-redux";

function AccountNumber({ form, handleCancel, handleProceed }) {
  const { saving } = useSelector((state) => state.auth);
  return (
    <div className="rounded-[0.75rem] bg-white shadow-[0_0_0_1px_rgba(0,0,0,0.05)] p-[0.75rem] mt-[1rem]">
      <div className="flex justify-between items-start">
        <div className="flex items-center gap-[0.5rem]">
          <div className="w-[1.5rem] h-[1.5rem] rounded-[0.375rem] bg-surface2 flex items-center justify-center">
            <img src={svg165} alt="svg165" />
          </div>
          <span className="text-ink font-[500] font-lexendS text-[1rem] leading-[1.5rem]">
            Enter Your Account Number
          </span>
        </div>

        <div className="py-[0.125rem] px-[0.5rem] rounded-[624.9375rem] bg-surface2 text-body text-[0.625rem] font-[500] leading-[0.9375rem] font-lexendS">
          Step 2/3
        </div>
      </div>

      <Form.Item
        name="accountNumber"
        className="mt-[.5rem]"
        label={<span>Account Number</span>}
        rules={[
          {
            required: true,
            message: "Please enter a valid account number.",
          },
        ]}
      >
        <Input className="input" />
      </Form.Item>

      <div className="flex justify-end items-center gap-x-[0.5rem] mt-[1rem]">
        <button
          type="button"
          onClick={handleCancel}
          className="flex items-center gap-[0.5rem] rounded-[624.9375rem] border border-line bg-white py-[0.5rem] px-[1rem] text-ink text-[0.875rem] font-[500] leading-[1.25rem] font-lexendS"
        >
          <img src={svg150} alt="close" />
          Close
        </button>

        <button
          type="button"
          disabled={saving}
          onClick={handleProceed}
          className="flex items-center gap-[0.5rem] rounded-[624.9375rem] bg-[#1E191B] py-[0.5rem] px-[1rem] text-white text-[0.875rem] font-[500] leading-[1.25rem] font-lexendS"
        >
          <img src={svg151} alt="buy" />
          {saving ? <Spin /> : "Proceed"}
        </button>
      </div>
    </div>
  );
}

export default AccountNumber;
